import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel, MenuItem, Select, Typography, Stack } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';
import { AccountState } from '@repo/api-gw-sdk';
import type { BackupVault } from '@/data/vaults/backupVault';
import { SelectPlaceholder } from '../selectPlaceholder';
export const VaultAccountBucketSelector = t0 => {
  const $ = _c(19);
  const {
    data,
    setData,
    vaultAccounts,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "8px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FormLabel>Vault account</FormLabel>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingLeft: "8px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = data.vaultAccountId || "";
  let t5;
  if ($[3] !== vaultAccounts) {
    t5 = value => {
      if (!value) {
        return <SelectPlaceholder />;
      }
      const account_0 = vaultAccounts.find(account => account.id === value);
      return account_0?.name || account_0?.providerAccountId || value;
    };
    $[3] = vaultAccounts;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== data || $[6] !== setData) {
    t6 = event => setData({
      ...data,
      vaultAccountId: event.target.value,
      vaultAttributes: {
        ...data.vaultAttributes,
        aws: event.target.value === data.vaultAccountId ? data.vaultAttributes.aws : undefined
      }
    });
    $[5] = data;
    $[6] = setData;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== vaultAccounts) {
    t7 = vaultAccounts.map(_temp);
    $[8] = vaultAccounts;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== disabled || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <FormControl size="small">{t2}<Select sx={t3} size="medium" value={t4} disabled={disabled} displayEmpty={true} renderValue={t5} onChange={t6}>{t7}</Select></FormControl>;
    $[10] = disabled;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Typography variant="body2" color="text.secondary">Eon creates and configures a bucket in this account and region. Eon manages the entire bucket policy and may overwrite your edits.</Typography>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <Stack sx={t1}>{t8}{t9}</Stack>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
function _temp(account_1) {
  return <MenuItem key={account_1.id} value={account_1.id} disabled={account_1.state === AccountState.ACCOUNT_STATE_DISCONNECTED}>{account_1.name || account_1.providerAccountId}{account_1.state === AccountState.ACCOUNT_STATE_DISCONNECTED && " (Disconnected)"}</MenuItem>;
}